
import React from 'react';
import logo from 'assets/logo.svg'
import './app_bar.scss'

export default ({...props}) => (
    <div className="app_bar">
        <span className="app_bar__title">Platsannonser</span>
    </div>
);